import { AppBar, Dialog, DialogContent, Hidden, IconButton, MenuItem, Stack, TextField, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import dayjs from 'dayjs';
import WeekOfYear from 'dayjs/plugin/weekOfYear';
import React, { useState } from 'react';
import { Menu, Search } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../authentication/useAuth';
import { setDrawerOpen, setSelectedSite } from '../../../store/global';
import { tokens } from '../../../theme';
import GlobalSearch from './GlobalSearch';
import ProfileButton from './ProfileButton';
import UpdateButton from './UpdateButton';
import UploadButton from './UploadButton';

const TopBar = () => {
    dayjs.extend(WeekOfYear);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    const { siteAccess = [] } = useAuth();
    const { siteSelected } = useSelector(state => state.global)
    const [searchOpen, setSearchOpen] = useState(false);
    // const isTablet = useIsTablet();
    // const isOnline = useOnlineStatus();

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer - 1,
                    height: '56px',
                    left: { xs: 0, md: '240px' },
                    width: { xs: '100%', md: 'calc(100% - 240px)' },
                    backgroundColor: tokens.navBg,
                    color: tokens.navInk,
                    borderBottom: `1px solid ${tokens.navDivider}`
                }}
            >
                <Toolbar sx={{ justifyContent: 'flex-end', minHeight: '56px !important', gap: 2 }}>
                    <Hidden mdDown>
                        <Box sx={{ flex: 1, maxWidth: 440, mr: 'auto' }}>
                            <GlobalSearch />
                        </Box>
                    </Hidden>
                    <Hidden mdUp>
                        <Box position="absolute" left="16px" display="flex" alignItems="center" gap={1.5}>
                            <Menu size={20} style={{ cursor: 'pointer' }} onClick={() => dispatch(setDrawerOpen())} />
                            <Typography fontWeight={600} color={tokens.navActiveInk}>IMS</Typography>
                        </Box>
                    </Hidden>
                    <Box display="flex" sx={{ gap: 2 }} alignItems="center">
                        <Stack direction="row" display="flex" gap={2} justifyContent="flex-start" alignItems="center">
                            <Hidden mdUp>
                                <IconButton size="small" aria-label="Search" onClick={() => setSearchOpen(true)} sx={{ color: tokens.navInk }}>
                                    <Search size={20} />
                                </IconButton>
                            </Hidden>
                            <UpdateButton />
                            <UploadButton />
                            <Stack direction={"row"} gap={1} justifyContent="flex-start" alignItems="center">
                                <Hidden mdDown>
                                    <Typography sx={{ whiteSpace: 'nowrap', fontSize: 13, color: tokens.navInkMuted }}>Site</Typography>
                                </Hidden>
                                {/* A list to pick from, not a box to type in; phones get their own native list */}
                                <TextField
                                    select
                                    size="small"
                                    SelectProps={{ native: isMobile }}
                                    value={(siteSelected ?? JSON.parse(localStorage.getItem('selectedSite')))?.siteId ?? ''}
                                    onChange={(e) => {
                                        const option = siteAccess?.find(s => s.siteId === e.target.value);
                                        const currentValue = siteSelected ?? JSON.parse(localStorage.getItem('selectedSite'));
                                        if (option && currentValue?.siteId !== option.siteId) {
                                            localStorage.setItem('selectedSite', JSON.stringify(option));
                                            dispatch(setSelectedSite(option));
                                            window.location.reload(false);
                                        }
                                    }}
                                    sx={{
                                        width: isMobile ? 'auto' : '220px',
                                        minWidth: '120px',
                                        '& .MuiOutlinedInput-root': { borderRadius: '999px', backgroundColor: tokens.navActive, color: tokens.navActiveInk, fontWeight: 500, fontSize: 14 }
                                    }}
                                >
                                    {(siteAccess ?? []).map(s => (
                                        isMobile
                                            ? <option key={s.siteId} value={s.siteId}>{s.siteName}</option>
                                            : <MenuItem key={s.siteId} value={s.siteId}>{s.siteName}</MenuItem>
                                    ))}
                                </TextField>
                            </Stack>
                        </Stack>
                        {/* <IF condition={!isTablet}>
                            <Stack sx={{ marginRight: 4 }} direction={'row'} gap={1} alignItems="center">
                                <Typography variant="subtitle1">{`Week ${dayjs().week()}`}</Typography>
                                <Divider
                                    orientation="vertical"
                                    sx={{ height: theme.spacing(3), borderWidth: '1px', borderColor: textColor }}
                                />
                                <Typography variant="subtitle2">{`${dayjs().format('ddd, DD MMM YYYY')}`}</Typography>
                            </Stack>
                        </IF> */}
                        {/* <IF condition={isTablet}>
                            <Stack sx={{ marginRight: 2 }} direction={'row'} gap={1} alignItems="center">
                                <Divider
                                    orientation="vertical"
                                    sx={{ height: theme.spacing(3), borderWidth: '1px', borderColor: textColor }}
                                />
                                <Stack>
                                    <Typography
                                        variant={isTablet ? 'subtitle2' : 'subtitle1'}
                                    >{`Week ${dayjs().week()}`}</Typography>
                                    <Typography variant={isTablet ? 'caption' : 'subtitle2'}>{`${dayjs().format(
                                        'ddd, DD MMM YYYY'
                                    )}`}</Typography>
                                </Stack>
                            </Stack>
                        </IF> */}
                        {/* <ToggleButton
                            onClick={() => dispatch(toggleNotifications())}
                            size="small"
                            value="notifications"
                            selected={notificationsOpen}
                            sx={{
                                border: 'none',
                                borderRadius: '50%'
                            }}
                        >
                            <Bell color={textColor} size={28} />
                        </ToggleButton>
                        <SettingsButton textColor={textColor} /> */}
                    <ProfileButton sx={{ padding: '0px', mr: '10px' }} />
                    </Box>
                </Toolbar>
            </AppBar>
            {/* Phones: the search opens over the page, at the top where the keyboard leaves room */}
            <Dialog open={searchOpen} onClose={() => setSearchOpen(false)} fullWidth PaperProps={{ sx: { alignSelf: 'flex-start', mt: 2, mx: 2, width: 'calc(100% - 32px)' } }}>
                <DialogContent sx={{ p: 1.5 }}>
                    <GlobalSearch autoFocus onDone={() => setSearchOpen(false)} />
                </DialogContent>
            </Dialog>
            {/* <IF condition={!isOnline}>
                <AppBar
                    sx={{
                        zIndex: (theme) => theme.zIndex.drawer - 1,
                        height: '8px',
                        top: '48px',
                        alignItems: 'center'
                    }}
                    position="fixed"
                    color="error"
                >
                    <Box display="flex">
                        <Box
                            sx={{
                                width: 0,
                                height: 0,
                                borderTop: `20px solid ${theme.palette.error.main}`,
                                borderLeft: '20px solid transparent'
                            }}
                        />
                        <Box bgcolor="error.main" width="120px" textAlign="center">
                            <Typography variant="body2">Offline</Typography>
                        </Box>
                        <Box
                            sx={{
                                width: 0,
                                height: 0,
                                borderTop: `20px solid ${theme.palette.error.main}`,
                                borderRight: '20px solid transparent'
                            }}
                        />
                    </Box>
                </AppBar>
            </IF> */}
        </>
    );
};

export default TopBar;
